import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import { observer } from 'mobx-react-lite';
import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import { LinearProgress, Typography } from '@mui/material';
import Amount from '@components/common/molecules/Amount';

interface OrderSubmitButtonProps {
    orderEditViewStore: OrderEditViewStore;
}

const OrderSubmitButton: React.FC<OrderSubmitButtonProps> = observer(({ orderEditViewStore }) => {
    const { isLoading, insertOrderAsync, totalAmount, isSubmitEnabled } = orderEditViewStore;

    return (
        <Button
            color='secondary'
            onClick={insertOrderAsync}
            disabled={isSubmitEnabled === false || isLoading}
            sx={{ width: "100%", boxShadow: (theme) => theme.shadows[3] }}
            variant='contained'>
            <Box display={"flex"} width={"100%"} flexDirection={"row"} justifyContent={"space-between"}>
                <Typography
                    textAlign={"start"}>
                    Naruči
                </Typography>
                <Amount amount={totalAmount} width={"auto"} fontWeight={600} />

                {isLoading &&
                    <Box position={"absolute"} bottom={0} left={0} width={"100%"}>
                        <CircularProgress />
                    </Box>
                }
            </Box>
        </Button>
    )
})

export default OrderSubmitButton;